import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule } from '@angular/forms';

import { PriceComponent } from './price/price.component';
import { PageTitleComponent } from '../core/page-title/page-title.component';
import { RawPricePipe } from './raw-price.pipe';

@NgModule({
    declarations: [
        PriceComponent,
        PageTitleComponent,
        RawPricePipe
    ],
    imports: [
        CommonModule,
        AppRoutingModule,
        FormsModule
    ],
  exports: [
    PriceComponent,
    PageTitleComponent,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    RawPricePipe
  ]
})
export class SharedModule {}
